import { render, staticRenderFns } from "./SiloMeasurement.vue?vue&type=template&id=47d2b8b2&scoped=true&"
import script from "./SiloMeasurement.vue?vue&type=script&lang=js&"
export * from "./SiloMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./SiloMeasurement.vue?vue&type=style&index=0&id=47d2b8b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2b8b2",
  null
  
)

export default component.exports